import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './RemovingIndicator.style';

const RemovingIndicator = ({ className: classNameProp, ...other }) => (
  <div className={clsx(styles.root, classNameProp)} {...other}>
    <Spinner size={SpinnerSize.small} className={styles.loadingSpinner} />
    <Text className={styles.savingText}>Removing...</Text>
  </div>
);

RemovingIndicator.propTypes = {
  className: PropTypes.string,
};

RemovingIndicator.defaultProps = {
  className: '',
};

export default RemovingIndicator;
